import { LanguageType } from '@/types/LanguageType';
import { CursorVisibilityType } from '@/types/CursorVisibilityType';
import { ThemeType } from '@/types/ThemeType';
import { AlignmentType } from '@/types/AlignmentType';
import { AnimationType } from '@/types/AnimationType';

export const DarkTheme: ThemeType = 'dark';
export const LightTheme: ThemeType = 'light';

export const PolishLanguage: LanguageType = 'pl';
export const EnglishLanguage: LanguageType = 'en';

export const CursorVisible: CursorVisibilityType = 'visible';
export const CursorHidden: CursorVisibilityType = 'hidden';

export const VerticalNavigationAlignment: AlignmentType = 'vertical';
export const HorizontalNavigationAlignment: AlignmentType = 'horizontal';

export const FadeDown: AnimationType = 'fade-down';
export const FadeUp: AnimationType = 'fade-up';
export const FadeLeft: AnimationType = 'fade-left';
export const FadeRight: AnimationType = 'fade-right';
export const FadeUpRight: AnimationType = 'fade-up-right';
